export default __webpack_public_path__ + "static/media/2122 utensils top.e904c3ee.png";